module.exports = __webpack_public_path__ + "static/media/pp-shield.85a74904.svg";